import { render, staticRenderFns } from "./xqDialog.vue?vue&type=template&id=01e54c82&scoped=true&"
import script from "./xqDialog.vue?vue&type=script&lang=js&"
export * from "./xqDialog.vue?vue&type=script&lang=js&"
import style0 from "./xqDialog.vue?vue&type=style&index=0&id=01e54c82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e54c82",
  null
  
)

export default component.exports